import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoSection() {
  const isFor = ['Mujeres que sufren de inflamación abdominal persistente ("pancita").', 'Quienes retienen líquidos y sienten pesadez en las extremidades.', 'Mujeres en etapa de pre-menopausia o post-parto que notan cambios en su silueta.', 'Aquellas que buscan un método estético efectivo sin pagar sesiones costosas en spa.'];
  const isNotFor = ['Personas que buscan una "pastilla mágica" para bajar 10 kilos de grasa sin mover un dedo.', 'Personas con condiciones médicas graves (insuficiencia renal o cardíaca) sin autorización médica.', 'Quienes no estén dispuestas a dedicar 15 minutos de autocuidado a su cuerpo.'];
  return <section className="py-16 md:py-24 px-4 bg-[#FAF3E8]" data-id="element-174">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#7C9A6E]" data-id="element-176">
          <h3 className="text-2xl font-heading font-bold text-[#3D2B1F] mb-6 flex items-center gap-2" data-id="element-177">
            <span className="bg-[#7C9A6E]/10 p-2 rounded-full" data-id="element-178">
              <CheckIcon className="w-6 h-6 text-[#7C9A6E]" data-id="element-179" />
            </span>
            ESTO SÍ ES PARA TI SI...
          </h3>
          <ul className="space-y-4" data-id="element-180">
            {isFor.map((item, index) => <li key={index} className="flex items-start gap-3 text-[#5A4332]" data-id="element-181">
                <div className="w-1.5 h-1.5 rounded-full bg-[#7C9A6E] mt-2.5 shrink-0" data-id="element-182" />
                <span data-id="element-183">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-[#D4654A]" data-id="element-184">
          <h3 className="text-2xl font-heading font-bold text-[#3D2B1F] mb-6 flex items-center gap-2" data-id="element-185">
            <span className="bg-[#D4654A]/10 p-2 rounded-full" data-id="element-186">
              <XIcon className="w-6 h-6 text-[#D4654A]" data-id="element-187" />
            </span>
            ESTO NO ES PARA TI SI...
          </h3>
          <ul className="space-y-4" data-id="element-188">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3 text-[#5A4332]" data-id="element-189">
                <div className="w-1.5 h-1.5 rounded-full bg-[#D4654A] mt-2.5 shrink-0" data-id="element-190" />
                <span data-id="element-191">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}